import {
  Group,
  Paper,
  Space,
  Text,
  SimpleGrid,
  UnstyledButton,
  Accordion,
  Center,
} from "@mantine/core";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useServerApi } from "../hooks/userServerApi";

import {
  IconUsers,
  IconUser,
  IconCircleCheck,
  IconNotes,
  IconTableImport,
  IconCirclePlus,
  IconUserCircle,
  IconBuildingBank,
  IconCircleMinus,
  IconActivity,
  IconCircleX,
  IconHeart,
  IconNote,
} from "@tabler/icons";

import CardStat from "./cardStat";
import { useAuthUser } from "react-auth-kit";

const DebitNotePageStats = forwardRef(
  ({ cols = 5, role, preQuery, ...props }, ref) => {
    const [api] = useServerApi();

    const [stats, setStats] = useState([]);
    const auth = useAuthUser();

    let result = null;
    const fetchStats = async () => {
      try {
        // switch (role) {
        //   case "CONSULTANT":
        //     result = await api.DebitNote.getStatSummary(auth().id);
        //     break;
        //   default:
        //     result = await api.DebitNote.getStatSummary();
        //     break;
        // }
        result = await api.DebitNote.getStatSummary(preQuery);
        // console.log("DebitNotePageStats >fetchStats", result);

        if (!result) return;

        setStats([
          {
            icon: IconNotes,
            color: "#0ED1EA",
            label: "Total",
            msg: result.stats.TOTAL ?? 0,
          },
          {
            icon: IconCircleMinus,
            color: "#FF9F43",
            label: "DFT",
            msg: result.stats.DFT ?? 0,
          },
          {
            icon: IconCircleCheck,
            color: "#00b341",
            label: "HOLD",
            msg: result.stats.HOLD ?? 0,
          },

          {
            icon: IconCircleCheck,
            color: "#00b341",
            label: "CONFIRMED",
            msg: result.stats.CONFIRMED ?? 0,
          },

          {
            icon: IconCircleCheck,
            color: "#00b341",
            label: "SETTLED",
            msg: result.stats.SETTLED ?? 0,
          },
          {
            icon: IconCircleCheck,
            color: "#00b341",
            label: "EXP",
            msg: result.stats.EXP ?? 0,
          },

          {
            icon: IconCircleX,
            color: "red",
            label: "CAN",
            msg: result.stats.CAN ?? 0,
          },

          {
            icon: IconCircleCheck,
            color: "#00b341",
            label: "PARTIAL PAID",
            msg: result.stats.PARTIAL ?? 0,
          },

          {
            icon: IconCircleX,
            color: "red",
            label: "WAITING PAYMENT",
            msg: result.stats.WAIT ?? 0,
          },
        ]);
      } catch (error) {
        console.log(error);
      }
    };

    useImperativeHandle(ref, () => ({
      refresh: fetchStats,
    }));

    useEffect(() => {
      fetchStats();
    }, [role, preQuery]);

    return (
      <>
        {/* <Accordion defaultValue="grids">
          <Accordion.Item value="grids">
            <Accordion.Control></Accordion.Control>
            <Accordion.Panel> */}
        <SimpleGrid
          cols={cols}
          breakpoints={[{ maxWidth: "sm", cols: 1 }]}
          {...props}
        >
          {stats?.map((stat, index) => (
            <CardStat key={index} stat={stat} />
          ))}
        </SimpleGrid>
        {/* </Accordion.Panel>
        </Accordion.Item>
      </Accordion> */}
      </>
    );
  }
);

export default DebitNotePageStats;
